module.exports = __webpack_public_path__ + "img/xtgl1.46f527cb.png";